import { FirestoreDocument } from '../../types';
import { getRowCellDescriptors, toPeekFieldType } from './document-row.domain';

export interface DocumentRowProps {
  document: FirestoreDocument;
  fields: string[];
  rowNumber: number;
  onClick: () => void;
  onPeek?: (value: unknown, fieldType: 'array' | 'map', fieldName: string) => void;
}

export interface RowCellViewModel {
  fieldName: string;
  value: unknown;
  isClickable: boolean;
  peekType: 'array' | 'map' | null;
}

export function useDocumentRow({ document, fields, rowNumber, onClick, onPeek }: DocumentRowProps) {
  const descriptors = getRowCellDescriptors(document, fields);
  const hasPeek = Boolean(onPeek);

  const cells: RowCellViewModel[] = descriptors.map((d) => ({
    fieldName: d.fieldName,
    value: d.value,
    isClickable: hasPeek && d.isPeekable,
    peekType: d.isPeekable ? toPeekFieldType(d.fieldType) : null,
  }));

  const handleCellClick = (
    e: React.MouseEvent,
    fieldName: string,
    value: unknown,
    peekType: 'array' | 'map' | null
  ) => {
    e.stopPropagation();
    if (onPeek && peekType) {
      onPeek(value, peekType, fieldName);
    }
  };

  return {
    rowNumber,
    documentId: document.id,
    cells,
    handleRowClick: onClick,
    handleCellClick,
  };
}
